import React, { useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import HotSwapFlowStepper from './components/how-swap-flow-stepper'
import ScheduleShippingStep from './components/sbu-flow/schedule-shipping'
import AddressShippingStep from './components/sbu-flow/address-shipping'
import HotSwapSummary from './components/how-swap-summary'
import { HOTSWAP_TYPES } from './constants/constants'
import HotSwapSuccess from './hot-swap-success'
import usePostHotSwap from './api/usePostHotSwap'

export default function HotSwapSbuFlow({
    selectedHotSwapLocations,
    setSelectedSwapOption
}) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const formRef = useRef()
    const [formData, setFormData] = useState(null)
    const [scheduledDate, setScheduledDate] = useState(null)
    const [isConfirmed, setIsConfirmed] = useState(false)
    const [
        isCheckedTermsAndConditions,
        setIsCheckedTermsAndConditions
    ] = useState(false)

    const hotSwapMutation = usePostHotSwap()

    const steps = useMemo(() => {
        return [
            {
                label: locale.hotSwap.swap_by_user.stepper.firstStepHeader,
                question:
                    locale.hotSwap.swap_by_user.stepper.firstStepSubHeader,
                step: (
                    <ScheduleShippingStep
                        selectedHotSwapLocations={selectedHotSwapLocations}
                        setScheduledDate={setScheduledDate}
                    />
                ),
                validate: () => validateDateStep()
            },
            {
                label: locale.hotSwap.swap_by_user.stepper.secondStepHeader,
                question:
                    locale.hotSwap.swap_by_user.stepper.secondStepSubHeader,
                step: (
                    <AddressShippingStep
                        selectedHotSwapLocations={selectedHotSwapLocations}
                        setFormData={values => setFormData(values)}
                        formRef={formRef}
                    />
                ),
                validate: () => validateAddressStep()
            },
            {
                label: locale.hotSwap.swap_by_user.stepper.thirdStepHeader,
                question:
                    locale.hotSwap.swap_by_user.stepper.thirdStepSubHeader,
                step: (
                    <HotSwapSummary
                        selectedHotSwapLocations={selectedHotSwapLocations}
                        swapType={HOTSWAP_TYPES.SBU}
                        scheduledDate={scheduledDate}
                        formData={formData}
                    />
                )
            }
        ]
    }, [
        locale.hotSwap.swap_by_user.stepper,
        selectedHotSwapLocations,
        formData,
        scheduledDate
    ])

    const handleCheckBoxClick = e => {
        setIsCheckedTermsAndConditions(e.target.checked)
    }

    // TODO: update this logic after backend work is done (update hotSwapData setting, maybe move logic for both SBU and US elsewhere)
    function handleConfirm() {
        const hotSwapData = {
            ...formData,
            streetAddress: formData.streetAndNumber,
            streetNumber: 1,
            hotswapType: HOTSWAP_TYPES.SBU,
            date: scheduledDate,
            time: '00:00',
            isCheckedTermsAndConditions,
            locations: selectedHotSwapLocations.map(l => l.id)
        }
        hotSwapMutation.mutate(hotSwapData, {
            onSuccess: () => {
                setIsConfirmed(true)
            },
            onError: error => {
                // TODO: show proper error msg
                console.error(error)
            }
        })
    }

    const validateAddressStep = async () => await formRef.current.submit()

    const validateDateStep = () => !!scheduledDate

    return (
        <div className={classes.wrapper}>
            {isConfirmed ? (
                <HotSwapSuccess swapType={HOTSWAP_TYPES.SBU} />
            ) : (
                <HotSwapFlowStepper
                    steps={steps}
                    handleConfirm={handleConfirm}
                    setSelectedSwapOption={setSelectedSwapOption}
                    isSwapByUserFlow={true}
                    isCheckedTermsAndConditions={isCheckedTermsAndConditions}
                    handleCheckBoxClick={handleCheckBoxClick}
                />
            )}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
}))
